import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-135">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-136">
        <img src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=1920&q=80" alt="Elegant ballroom at H2O Event Centre" className="w-full h-full object-cover object-center" data-id="element-137" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-h2o-950/90" data-id="element-138" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center text-center mt-20" data-id="element-139">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="max-w-4xl flex flex-col items-center" data-id="element-140">
          <motion.span variants={itemVariants} className="text-h2o-cyan font-semibold tracking-[0.2em] text-sm md:text-base mt-16 md:mt-12 mb-6 uppercase" data-id="element-141">
            Maryland's Premier Event Destination
          </motion.span>

          <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight" data-id="element-142">
            Where Moments Turn Into{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-143">
              Memories
            </span>
          </motion.h1>

          <motion.h2 variants={itemVariants} className="text-2xl md:text-3xl font-heading text-slate-300 mb-8 font-medium" data-id="element-144">
            H2O Event Centre
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-slate-400 mb-12 max-w-2xl leading-relaxed" data-id="element-145">
            An extraordinary venue for life's most extraordinary occasions. From
            intimate gatherings to grand celebrations, every detail is crafted
            to perfection.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 sm:gap-6 w-full sm:w-auto" data-id="element-146">
            <Link to="/contact" className="bg-h2o-cyan text-h2o-950 font-semibold px-8 py-4 rounded-lg hover:bg-h2o-cyan-light transition-colors duration-300 focus-visible-ring w-full sm:w-auto flex items-center justify-center" data-id="element-147">
              Request a Tour
            </Link>
            <Link to="/services" className="bg-transparent border border-h2o-cyan text-h2o-cyan font-semibold px-8 py-4 rounded-lg hover:bg-h2o-cyan/10 transition-colors duration-300 focus-visible-ring w-full sm:w-auto flex items-center justify-center" data-id="element-148">
              View Packages
            </Link>
          </motion.div>

          {/* Scroll Indicator */}
          <motion.div variants={itemVariants} className="mt-12 flex flex-col items-center gap-2 text-slate-400" data-id="element-149">
            <span className="text-xs uppercase tracking-widest font-medium" data-id="element-150">
              Scroll to explore
            </span>
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-151">
              <ChevronDown className="w-5 h-5 text-h2o-cyan" data-id="element-152" />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}